import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import type { CSSProperties } from 'react';

interface TruncatedLabelWithSecondaryProps {
  label: string;
  secondaryLabel?: string | null;
  tooltipContentStyle?: CSSProperties;
}

export const TruncatedLabelWithSecondary = ({
  label,
  secondaryLabel,
  tooltipContentStyle,
}: TruncatedLabelWithSecondaryProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className="flex min-w-0 items-center">
        <span className="min-w-0 truncate">{label}</span>
        {secondaryLabel ? (
          <span className="flex shrink-0 items-center text-text-neutral-secondary">
            <span className="mx-1">—</span>
            <span className="text-xs">{secondaryLabel}</span>
          </span>
        ) : null}
      </span>
    </TooltipTrigger>
    <TooltipContent style={tooltipContentStyle}>
      {label}
      {secondaryLabel ? <span className="mx-1">—</span> : null}
      {secondaryLabel}
    </TooltipContent>
  </Tooltip>
);
